import type { ProductPrice } from "@viajero/proto/guest/v1";
import type { PriceQuantities } from "@/lib/courseBookingContext";

/**
 * 価格種別ごとの単価 (ProductPrice) と選択人数 (PriceQuantities) から合計金額を算出する。
 * コース詳細画面 (CourseDetailView) と購入者情報入力画面 (BuyerInfoStep/PurchaseSummarySection)
 * の双方で同じ計算が必要なため共通化する。
 */
export function calculateTotalPrice(prices: ProductPrice[], quantities: PriceQuantities): number {
  return prices.reduce(
    (sum, price) => sum + Number(price.price) * (quantities[price.priceTypeId.toString()] ?? 0),
    0,
  );
}
